import { Image, Page, View } from "@react-pdf/renderer";
import { ReactNode } from "react";
import PrintHeader from "./Header";
import Stamp from "../../../assets/print/stamp.png";
import PrintFooter from "./Footer";

export default function PrintNewPage({
    children,
    orientation = "portrait",
}: {
    children: ReactNode;
    orientation?: "landscape" | "portrait";
}) {
    return (
        <Page
            size="A4"
            orientation={orientation}
            style={{
                padding: 20,
                paddingTop: 0,
                paddingBottom: 0,
                height: "100%",
                fontSize: "8px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <View>
                <PrintHeader />
                {children}
            </View>
            <View
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    width: "100%",
                }}
            >
                <Image src={Stamp} style={{ width: "100px" }} />
            </View>

            <PrintFooter />
        </Page>
    );
}
